<app-widget-asset-preview
    [asset]="getAsset(key)"
    (selectFiles)="onFilesSelected($event)"
    [editable]="true"
    [dataTestId]="'product-featured-asset'"
/>
